import { Component, inject, OnDestroy, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { Subject, takeUntil } from 'rxjs';
import { CertifiableSystem } from '@workspace-app/odatabackend/QualicoatBackendModel';
import { ApprovedSystemViewComponent } from './approved-system-view.component';
import { AutoCloseOverlayMixin } from '../../../../shared/mixins/auto-close-overlay.mixin';
import { ApprovedSystemsGridService } from '../../services/approved-systems-grid.service';

@Component({
  selector: 'app-approved-system-overlay',
  imports: [ApprovedSystemViewComponent],
  template: `
    @if (system()) {
      <app-approved-system-view [systemInput]="system()!" />
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [],
})
export class ApprovedSystemOverlayComponent extends AutoCloseOverlayMixin implements OnInit, OnDestroy {
  private config = inject(DynamicDialogConfig);
  private gridService = inject(ApprovedSystemsGridService);

  system = signal<CertifiableSystem | undefined>(undefined);
  private closeSubscription$ = new Subject<void>();

  constructor() {
    super();
    this.system.set(this.config.data.system);
  }

  override ngOnInit(): void {
    super.ngOnInit();

    // Subscribe to close dialog events
    this.gridService.closeDialogs.pipe(takeUntil(this.closeSubscription$)).subscribe(() => this.dialogRef.close());

    // Subscribe to system updates to refresh the dialog when system is modified
    this.gridService.systemUpdated.pipe(takeUntil(this.closeSubscription$)).subscribe((updatedSystem) => {
      const currentSystem = this.system();
      if (currentSystem && updatedSystem.id === currentSystem.id) {
        this.system.set(updatedSystem);
      }
    });
  }

  override ngOnDestroy(): void {
    this.closeSubscription$.next();
    this.closeSubscription$.complete();
    super.ngOnDestroy();
  }
}
